let wx = require('weixin-js-sdk');
import {Toast} from 'mint-ui';


/*
微信支付方法
获取微信加签信息
@param{data}:获取的微信加签
@param{cb}:成功回调
*/


let wexinPay = (jsdk,pay,cb,errorCb) => {
    let appId = jsdk.appId;
    let timestamp = jsdk.timestamp;
    let nonceStr = jsdk.nonceStr;
    let signature = jsdk.signature;

    let pay_timestamp = pay.timeStamp;
    let pay_nonceStr = pay.nonceStr;
    // let pay_signature = pay.signature;
    let packages = pay.package;
    let paySign = pay.paySign;
    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名，见附录1
        jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });

    wx.ready(function(){
        wx.chooseWXPay({
            timestamp: pay_timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: pay_nonceStr, // 支付签名随机串，不长于 32 位
            package: packages, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
            signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: paySign, // 支付签名
            success: function(res) {
                // 支付成功后的回调函数

                cb(res);
            },
            fail:function(res){
                Toast({
                    message: res,
                    position: 'bottom',
                    duration: 5000
                })
                errorCb(res);
            }
        });
    });
    wx.error(function(res) {
        Toast({
            message: res,
            position: 'bottom',
            duration: 5000
        })
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        /*alert("config信息验证失败");*/
    });
}
export default wexinPay;